/**
 * The BannerComponent function is a React component that displays a carousel of banners, with the
 * ability to navigate between them and click on them to go to a shop page.
 * @returns The BannerComponent JSX code is being returned.
 */
import React, { useState, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import "./bannerComponent.css";
import Slider from "react-slick";

const BannerComponent = () => {
  const bannersDataArr = useSelector((state) => state.banners);
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Call handleResize on initial render
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    slidesToShow: bannersDataArr.length,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 2400,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {bannersDataArr.length > 0 && (
        <div
          id="homeBannerCarousel"
          className="container homeBannerCarousel carousel slide pt-sm-4 pb-sm-4 py-2 px-0"
          data-ride="carousel"
          data-interval="5000"
        >
          <div className="carousel-inner">
            <Slider {...sliderSettings}>
              {bannersDataArr.map((bannerVo, index) => (
                <div
                  className={`carousel-item ${
                    index == 0 && "active"
                  } homeslide ${index + 1}`}
                  key={bannerVo.banner_id}
                  // style={{ backgroundImage: `url(${bannerVo.src})` }}
                >
                  {/* <Link
                    to="/shop"
                    type="button"
                    style={{ width: "100%", height: "100%", padding: "0.7rem" }}
                  > */}
                  <div>
                    <img
                      className={`bannerImage ${
                        isMobile ? "mobilebanner" : "main_shadow desktopbanner"
                      }`}
                      src={bannerVo.src}
                      style={{
                        borderRadius: "8px",
                        padding: isMobile ? "5px" : 0,
                      }}
                      // style={{width:'100%',  minWidth:isMobile ? "1320px" : "375px", minHeight:isMobile ? "154px" : "340"}}
                      alt={bannerVo.banner_title}
                      width={isMobile ? "375" : "1320"}
                      height={isMobile ? "154" : "240"}
                    />
                    {/* </Link> */}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

export default BannerComponent;
